import { differenceInMonths, differenceInCalendarDays, parseISO } from "date-fns";
import { todayIso } from "@/lib/format";

export function workPeriod(start, end) {
  if (!start || !end || end < start) return { months: 0, days: 0, label: "-" };
  const s = parseISO(start), e = parseISO(end);
  const months = differenceInMonths(e, s);
  const days = differenceInCalendarDays(e, s) + 1;
  const y = Math.floor(months / 12), m = months % 12;
  const label = `${y ? `${y} tahun ` : ""}${m} bulan`;
  return { months, days, label };
}

export function calcJaminan(cfg, endOverride) {
  const end = endOverride || cfg?.end || todayIso();
  const p = workPeriod(cfg?.start, end);
  const deposit = Number(cfg?.deposit || 0);
  const depositMonthly = Number(cfg?.deposit_monthly || 0) * p.months;
  const saving = Number(cfg?.saving_monthly || 0) * p.months;
  return { ...p, end, deposit, depositMonthly, saving, total: deposit + depositMonthly + saving };
}
